<template>
  <div class="service">
    <div class="service__wrp">
      <p class="service__title">
        {{ _T("@For service inquiries") }}
      </p>

      <div class="service__contact">
        <p>
          {{ _T("@Service center Odesa") }}
        </p>
        <div class="service__comm-wrp">
          <a
            class="service__button-transparent"
            :href="`tel:${_T('@Service phone Odesa')}`"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                class="contact__btn-img"
                d="M18.1183 14.702L14.0001 15.5C11.2184 14.1038 9.50009 12.5 8.50009 10L9.27004 5.8699L7.81461 2L4.06369 2C2.93614 2 2.04823 2.93178 2.21663 4.04668C2.63704 6.83 3.87662 11.8765 7.50009 15.5C11.3053 19.3052 16.7858 20.9564 19.8021 21.6127C20.9669 21.8662 22.0001 20.9575 22.0001 19.7655L22.0001 16.1812L18.1183 14.702Z"
                stroke="#F36C21"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>{{ _T("@Service phone Odesa") }}</span>
          </a>
          <div class="service__messengers">
            <a
              class="service__messenger"
              :href="viberFormatPhone(_T('@Service phone Odesa'))"
              target="_blank"
            >
              <img
                class="service__messenger-img"
                src="~~/assets/icons/contactsManagerViber.svg"
                alt=""
              />
            </a>
            <a
              class="service__messenger"
              :href="telegramFormatPhone(_T('@Service phone Odesa'))"
              target="_blank"
            >
              <img
                class="service__messenger-img"
                src="~~/assets/icons/contactsManagerTelegram.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      <div class="service__contact">
        <p>
          {{ _T("@Service center Kolomyia") }}
        </p>
        <div class="service__comm-wrp">
          <a
            class="service__button-transparent"
            :href="`tel:${_T('@Service phone Kolomyia')}`"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                class="contact__btn-img"
                d="M18.1183 14.702L14.0001 15.5C11.2184 14.1038 9.50009 12.5 8.50009 10L9.27004 5.8699L7.81461 2L4.06369 2C2.93614 2 2.04823 2.93178 2.21663 4.04668C2.63704 6.83 3.87662 11.8765 7.50009 15.5C11.3053 19.3052 16.7858 20.9564 19.8021 21.6127C20.9669 21.8662 22.0001 20.9575 22.0001 19.7655L22.0001 16.1812L18.1183 14.702Z"
                stroke="#F36C21"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>{{ _T("@Service phone Kolomyia") }}</span>
          </a>
          <div class="service__messengers">
            <a
              class="service__messenger"
              :href="viberFormatPhone(_T('@Service phone Kolomyia'))"
              target="_blank"
            >
              <img
                class="service__messenger-img"
                src="~~/assets/icons/contactsManagerViber.svg"
                alt=""
              />
            </a>
            <a
              class="service__messenger"
              :href="telegramFormatPhone(_T('@Service phone Kolomyia'))"
              target="_blank"
            >
              <img
                class="service__messenger-img"
                src="~~/assets/icons/contactsManagerTelegram.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>

      <div class="service__map-section">
        <p class="service__map-title">
          {{ _T("@Service centres") }}
        </p>

        <div class="service__map-wrp" :class="{ active: activeMap }">
          <button class="service__button-show" @click="activeMap = !activeMap">
            <span v-if="activeMap" class="service__button-title">
              {{ _T("@Collapse map") }}
            </span>
            <span v-else class="service__button-title">{{
              _T("@Show map")
            }}</span>
            <span class="service__icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 15L12 9L6 15"
                  stroke="#1F1F1F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </button>
          <div class="service__block-map-w">
            <iframe
              class="service__map"
              src="https://www.google.com/maps/d/u/0/embed?mid=1pKtfgnpsEbVMugGGP8Of1SqUFuv26MY&ehbc=2E312F"
              style="border: 0"
              aria-hidden="false"
              tabindex="0"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatPhone } from "~~/utils/phoneHelper";

const activeMap = ref(true);

function telegramFormatPhone(phone) {
  const telegramPhone = formatPhone(phone);
  return "https://t.me/" + telegramPhone;
}

function viberFormatPhone(phone) {
  const telegramPhone = formatPhone(phone);
  return "viber://chat/?number=%2B" + telegramPhone.replace("+", "");
}
</script>

<style lang="scss" scoped>
.service {
  &__wrp {
    @include flex-container(column, null);

    gap: 24px;
  }

  &__title {
    @include font();
    letter-spacing: 0.02em;
    color: #1f1f1f;
  }

  &__contact {
    @include flex-container(column, null, flex-start);

    gap: 8px;
  }

  &__comm {
    width: max-content;

    @include flex-container(row, space-between, center);

    gap: 24px;

    &:hover {
      & > span {
        color: var(--color-primary-dark);
      }
    }

    & > span {
      @include font(14, 16);
      color: #2b2b2b;

      transition: color 0.1s ease-in-out;
    }
  }

  &__comm-wrp {
    @include flex-container(row, flex-start, center);

    gap: 32px;
  }

  &__messengers {
    @include flex-container(row, flex-start, center);

    gap: 16px;
  }

  &__btn-call {
    @include mobile {
      max-width: 100%;
    }
  }

  &__map-section {
    @include flex-container(column, null);

    gap: 16px;
  }

  &__map-title {
    @include font(20, 28);
    letter-spacing: 0.02em;
    color: black;
  }

  &__map-wrp {
    @include flex-container(column, null);

    gap: 8px;

    &.active {
      .service__icon {
        transform: rotateZ(0);
      }

      .service__block-map-w {
        height: 525px;
      }
    }
  }

  &__button-show {
    width: 100%;

    @include flex-container(row, space-between, center);

    background-color: #e9e9e9;

    border-radius: 2px;

    padding: 8px 16px;
  }

  &__button-title {
    @include font();
    letter-spacing: 0.02em;
    color: #1f1f1f;
  }

  &__icon {
    font-size: 0;

    transform: rotateZ(180deg);

    transition: transform 0.2s ease-in-out;
  }

  &__block-map-w {
    width: 100%;
    max-height: 100%;
    height: 0;

    border: none;

    @include flex-container(row, center, center);

    overflow: hidden;
    transition: height 0.3s ease-in-out;
  }

  &__map {
    width: 100%;
    height: 523px;
  }

  &__button-transparent {
    max-width: max-content;
    width: 100%;

    @include flex-container(row, flex-start, center);
    gap: 16px;

    border: 1px solid var(--color-primary-base);
    border-radius: 8px;

    padding: 8px 32px;

    color: var(--color-primary-base);
    font-size: 16px;

    transition:
      background-color 0.2s,
      border-color 0.2s;

    &:hover {
      border-color: #ff5b00;
      background-color: #ff5b00;

      & span {
        color: white;
      }

      .contact__btn-img {
        stroke: white;
      }
    }

    @include mobile {
      padding: 4px 8px;
    }
  }
}
</style>
